import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { platformLicenseActivationInSelectedBusinessPartnerById, selectedCompanyId, selectedRegulatorId } from 'src/app/store/store';
import { PlatformLicenseActivationFormComponent } from '../../components/platform-license-activation-form/platform-license-activation-form.component';
import { getValueFromStore, waitForBooleanValue } from '../../utils';
import { UpsertCompanyPlatformLicenseActivation } from 'src/app/store/actions/company.actions';
import { companyActionError, companyActionLoading } from 'src/app/store/reducer/company.reducer';
import { PlatformLicenseActivationDTO } from '@iota/iota-management-portal-v4-client';
import { UpsertCentralRegulatorPlatformLicenseActivation } from 'src/app/store/actions/central-regulators.actions';
import { centralRegulatorsActionError, centralRegulatorsActionLoading } from 'src/app/store/reducer/central-regulators.reducer';

export interface PlatformLicenseActivationDialogData {
    platformLicenseActivationId?: string;
}

@Component({
    standalone: false,
    selector: 'app-platform-license-activation-dialog',
    templateUrl: './platform-license-activation-dialog.component.html',
    styleUrls: ['./platform-license-activation-dialog.component.scss']
})
export class PlatformLicenseActivationDialogComponent implements OnInit {
    @ViewChild('platformLicenseActivationForm') licenseActivationForm: PlatformLicenseActivationFormComponent;

    public modalOptions = {
        size: IotaModalSize.SIZE_7XL
    };

    actionLoading$ = this.store.select(companyActionLoading);
    actionError$ = this.store.select(companyActionError);

    licenseActivation$: Observable<PlatformLicenseActivationDTO>;
    dateFormValid = false;

    constructor(
        private dialogRef: MatDialogRef<PlatformLicenseActivationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PlatformLicenseActivationDialogData,
        private store: Store
    ) {}

    ngOnInit(): void {
        if (this.data?.platformLicenseActivationId) {
            this.licenseActivation$ = this.store.select(
                platformLicenseActivationInSelectedBusinessPartnerById(this.data.platformLicenseActivationId)
            );
        }
    }

    async updateLicenseActivation() {
        if (!this.dateFormValid) return;

        const companyId = await getValueFromStore(this.store, selectedCompanyId);
        const centralRegulatorId = await getValueFromStore(this.store, selectedRegulatorId);

        const previousLicenseActivation = await getValueFromStore(
            this.store,
            platformLicenseActivationInSelectedBusinessPartnerById(this.data.platformLicenseActivationId)
        );
        const updatedFields = this.licenseActivationForm.getUpsertedPlatformLicenseActivation();
        const updatedLicenseActivation: PlatformLicenseActivationDTO = { ...previousLicenseActivation, ...updatedFields };

        let error: any = undefined;
        if (companyId) {
            this.store.dispatch(UpsertCompanyPlatformLicenseActivation({ plaformLicenseActivation: updatedLicenseActivation }));
            await waitForBooleanValue(this.store, companyActionLoading, false);
            error = await getValueFromStore(this.store, companyActionError);
        } else if (centralRegulatorId) {
            this.store.dispatch(UpsertCentralRegulatorPlatformLicenseActivation({ plaformLicenseActivation: updatedLicenseActivation }));
            await waitForBooleanValue(this.store, centralRegulatorsActionLoading, false);
            error = await getValueFromStore(this.store, centralRegulatorsActionError);
        }

        if (!error) this.closeDialog();
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
